/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function () {
    var filterButtons = document.querySelectorAll('.size-filter-btn');
    var collectionSection = document.querySelector('.collection');

    // Function to update button states
    function updateButtonStates() {
      filterButtons.forEach(function (button) {
        var filterValue = button.getAttribute('data-filter');
        var filterCheckbox = document.querySelector(`input[value="${filterValue}"]`);
        var ukFilterValue = getUKFilterValue(filterValue);
        var ukFilterCheckbox = document.querySelector(`input[value="${ukFilterValue}"]`);
        
        if ((filterCheckbox && filterCheckbox.checked) || (ukFilterCheckbox && ukFilterCheckbox.checked)) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });
    }


    // Add event listeners for size filter buttons
    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filterValue = this.getAttribute('data-filter');
        var filterCheckbox = document.querySelector(`input[value="${filterValue}"]`);
        var ukFilterValue = getUKFilterValue(filterValue);
        var ukFilterCheckbox = document.querySelector(`input[value="${ukFilterValue}"]`);
        
        if (filterCheckbox) {
          filterCheckbox.click();
        }
        if (ukFilterCheckbox) {
          ukFilterCheckbox.click();
        }
        updateButtonStates(); // Update button states after a checkbox is clicked
      });
    });

    // Add event listeners to checkboxes to track changes
    function addCheckboxListeners() {
      var checkboxes = document.querySelectorAll('input[name="filter.v.option.size"], input[name="filter.v.availability"]');
      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          updateButtonStates(); // Update button states when a checkbox state changes
        });
      });
    }

    // Get the corresponding UK filter value for a given size
    function getUKFilterValue(size) {
      switch (size) {
        case 'S':
          return 'UK 6 - 8';
        case 'M':
          return 'UK 10 - 12';
        case 'L':
          return 'UK 14 - 16';
        case 'XL':
          return 'UK 18 - 20';
        default:
          return '';
      }
    }

    // Use MutationObserver to detect changes in the collection section
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        updateButtonStates(); // Update button states on mutation
        addCheckboxListeners(); // Reapply event listeners to new checkboxes
      });
    });

    // Configure and start the observer
    observer.observe(collectionSection, {
      childList: true,
      subtree: true
    });

    // Initial update of button states and add listeners on page load
    updateButtonStates();
    addCheckboxListeners();
  });

  

 

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
